module.exports = __webpack_public_path__ + "static/media/play-triple.bd00a31d.png";